import { Box, Button, Checkbox, Dialog, Drawer, FormControlLabel, Menu, MenuItem, styled, Switch, TextField, Tooltip, Typography} from "@mui/material";
import { getDataSource } from "api/ds";
import { AddProducts } from "components/AddProducts";
import { FindTextField } from "components/FindTextField";
import { ReportTable } from "components/reportTable";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Helmet from "react-helmet";
import { colors } from "styles/colors";
import { ElementInfo } from "components/ElementInfo";
import { useQuery } from "react-query";
import Loading from "components/Load";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import Scrollbars from "rc-scrollbars";
import { MarketClientSelector } from "store/slices/marketClient";
import ClassicSearch from "components/classicSearch";
import { get, post } from "api/apiBridges/httpBridge";
import { useNavigate } from "react-router-dom";
import { setTab } from "store/slices/tabSlice";
import MoveGuideDialog from "components/MoveGuideDialog";
import { useLocalNotifications } from "components/Events";
import { ShowModal } from "components/Modal";
import BlockIcon from '@mui/icons-material/Block';
import { fetchData } from "pdfjs-dist";
import { hoverStyle } from "styles/main";


const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 100,
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '50%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 100 - 50 - 2 = 48px смещения
            transform: 'translateX(48px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                content: "'FBO'",
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'FBS'",
            left: 8,
        },
        '&::after': {
            content: "'FBO'",
            right: 8,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 50,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '50%',
            left: 12,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'FBS'",
        },
    },
}));

// Сделки
// Здесь отображаются сделки, далее переход по ней и создание (выбор товаров)
export function CreateDelivery() {
    // для открытия окна с товарами
    
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    const [FBS, setFBS] = useState(false);
    // для шторки
    const [info, setInfo] = useState({ open: false, info: null });

    /** @type {[any, Function]} */
    const [anchorSettings, setAnchorSettings] = useState(false);// якорь для  меню настроек
    const openSettings = Boolean(anchorSettings);// открыт ли Popover настроек
    const [isDelivery, setDelivery] = useState(false);// якорь для  меню настроек

    // загружаем дескриптор  и немного его изменяем чтобы показывать детали сделки
    const ds = useMemo(() => {
        const $ds = getDataSource('createDelivery'); 
        $ds.descr.showDetails = (obj) => {
            console.log(obj);
            setInfo({ open: true, info: obj.id });
        };
        return $ds;
    }, []);

    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            id: {name: "Номер", active: true},
            warehouse_market: {name: "Склад назначения", active: true},
            products: {name: "Товары", active: true},
        }
    );

    /** @type {[any, Function]} */
    const [clickedRow, setClickedRow] = useState(undefined);
    

    const { user_id } = useSelector(
        loginSelector
    );
    const { market } = useSelector(MarketClientSelector);

    const navigate = useNavigate();

    // получение сделок
    const getData = async () => {
        if (ds?.get) {
            setLoading(true)
            const res = await ds.get(user_id, market);
            res.map((el) => {
                el.dealDetails.actions = {
                    combined: (e) => {setClickedRow(el.id)}
                }
            })
            setData(res)
            setLoading(false)
        } else {
            return [];
        }
    }

    const getDataFBS = async () => {
        try {
            setLoading(true)
            const res = await get("Deal/GetCliFbsDeals", {cid: user_id, market})
            setData(res)
        }
        catch {}
        finally {
            setLoading(false)
        }
    }

    const getDataType = () => {
        if (FBS) {
            getDataFBS()
        }
        else {
            getData()
        }
    }
    
    useEffect(() => {
        if (market && user_id) {
            getDataType()
        }
    }, [ds, market, FBS, user_id]); 

    const totalEtimated = data.reduce((sum, item) => {
        const unitsCount = item.includes_products?.counts.epSum || 0;
        return sum + unitsCount;
    }, 0);

    const totalProducts = data.reduce((sum, item) => {
        const productCount = item.includes_products?.counts.cphSum || 0;
        return sum + productCount;
    }, 0);

    const handleChangeSwitch = (event) => {
        if (!event.target.checked) {
            //fbs
            setFBS(true)
        } else {
            setFBS(false)
        }
    };

    
    //Функции для открытия и закрытия настроек
    const openMenuSettigs = async (event) => {
        setAnchorSettings(event.currentTarget);

    }

    const handleCloseSettings = () => {
        setAnchorSettings(null);
    };

    const createDeal = (delivery = true) => {
        // setDelivery(delivery)
        setOpen(true)
    }
    
    // const getMeMyDefects = async () => {
    //     await post("Deal/getMeMyDefects", {cid: user_id})
    // }

    const dispatch = useDispatch();

    const { showNotification } = useLocalNotifications();
    
    const cancelDeal = async (did) => {    
        
        const cancelDeal = async (id) => {
            setLoading(true)
            let deal = data.find((fel) => fel.id == did)

            try {
                let flag = await get("Deal/checkCanCancel", {did})
                if (flag.can) {
                    if (deal.move_guide || deal.dealDetails.ret || deal.dealDetails.selfret) {
                        await post("Deal/cancelDealWithmoveGuide", {did: id})
                    }
                    else {
                        await post("Deal/cancelDealSimple", {did: id})
                    }
                    await getDataType()
                    showNotification({
                        id: 'successCancel', // Уникальный идентификатор
                        type: 'success', // Тип уведомления
                        message: 'Сделка откатилась' // Текст сообщения
                    });
                }
                else {
                    await getDataType()
                    showNotification({
                        id: 'cantCancel', // Уникальный идентификатор
                        type: 'warning', // Тип уведомления
                        message: 'Сделку уже нельзя отменить' // Текст сообщения
                    });
                }
            }
            catch {
                showNotification({
                    id: 'errorCancel',
                    type: 'error',
                    message: 'Не удалось отменить сделку, сообщите администратору'
                });
            }
            setLoading(false)
        }
        
    
        ShowModal('Отмена сделки', 
            <div>Вы уверены, что хотите отменить сделку?</div>, 
            async () => {
                try {
                    cancelDeal(did)
                }
                catch (err) {}
                finally {}        
            }
        );
    
    }
    
    console.log("DATA DELIVERY", data)

    return (
        <Box sx={{ width: '100%', height: '100%'}}>
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    {/* <AddProducts cancel={setOpen} isDelivery={isDelivery}></AddProducts> */}
                    <AddProducts cancel={setOpen}></AddProducts>
                </div>
            </Dialog>
            <div style={{ height: "5%", display: 'flex', width: '100%', padding: 'calc(2% - 5px) 1% 1% 1%', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{display: "flex", flexDirection: 'row', alignItems: 'center'}}>
                    <ClassicSearch setChecked={setChecked} setFilter={setFilter} checked={checked}/>
                    <FormControlLabel label={undefined} sx={{ padding: 0}}
                        control={<MaterialUISwitch defaultChecked={true} onChange={handleChangeSwitch} />}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <Box sx={{
                        zIndex: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        padding: '15px 20px',
                        borderRadius: '10px',
                        minWidth: '250px',
                        height: '36px', 
                        justifyContent: 'center'
                    }}>
                        {loading? <Loading></Loading>: 
                        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row"}}>
                            <Typography sx={{ fontSize: '11pt' }}>
                                Кол-во сделок: {data.length}
                            </Typography>
                            <Typography sx={{ fontSize: '11pt' }}>
                                Кол-во заявленного товара: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{totalEtimated} шт.</Typography>
                            </Typography>
                            <Typography sx={{ fontSize: '11pt' }}>
                                Кол-во фактического товара: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{totalProducts} шт.</Typography>
                            </Typography>
                        </Box>
                        }
                    </Box>

                    <Button 
                        variant="contained" 
                        onClick={(e) => { createDeal() }} 
                        sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: "10px"}}
                    >
                        Новая сделка
                    </Button>
                    {/* <Menu
                        id="new-menu"
                        // @ts-ignore
                        anchorEl={anchorSettings}
                        open={openSettings}
                        onClose={handleCloseSettings}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={() => createDeal()}>Поставка</MenuItem>
                        <MenuItem onClick={() => createDeal(false)}>Из расходников</MenuItem>
                    </Menu> */}
                </div>
            </div>
            <div style={{
                width: '98%', 
                height: 'calc(89% + 5px)', 
                overflow: 'hidden',
                margin: "1%",
                borderRadius: "10px",
                backgroundColor: 'white'
            }}>
                
                {loading? <Loading></Loading>: 
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
                >
                    <ReportTable 
                        ds={ds} 
                        data={!checked ? data : data.filter((el) => {
                            const tf = filter.toLowerCase(); 
                            return (
                                (filterFields.id.active && el.data.cdn && String(el.data.cdn).includes(tf)) || 
                                (filterFields.warehouse_market.active && el.warehouse_market && String(el.warehouse_market).toLowerCase().includes(tf)) || 
                                (filterFields.products.active && el.includes_products.products && el.includes_products.products.map(p => p.title).join("").toLowerCase().includes(tf))
                            );
                        })}
                        aditionalAction={
                            [
                                {
                                    action: (item) => { cancelDeal(item.id) },
                                    ui: () => {
                                        return (
                                            <Tooltip title={"Отменить сделку"}>
                                                <BlockIcon 
                                                    sx={{
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': hoverStyle
                                                    }
                                                }/>
                                            </Tooltip>
                                        )
                                    },
                                    flag: "canCancel"
                                }
                            ]
                        }
                    />
                </Scrollbars>}
            </div>

            <Drawer
                anchor='right'
                open={info.open}
                onClose={() => { setInfo({ open: false, info: null }) }}
            >
                <ElementInfo 
                    ds={getDataSource('EICreateDelivery')} 
                    // @ts-ignore
                    data={info.info} />
            </Drawer>
            <MoveGuideDialog deal_id={clickedRow} open={clickedRow} onClose={() => {setClickedRow(undefined)}} admin={false}/>

        </Box>

    );
}